import * as React from 'react';

const SvgPlus = props => (
	<svg
		aria-hidden="true"
		data-prefix="fas"
		data-icon="plus"
		viewBox="0 0 448 512"
		className="svg-inline--fa fa-plus fa-w-14"
		width="1em"
		height="1em"
		{...props}
	>
		<path
			fill="currentColor"
			d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
		/>
	</svg>
);

export default SvgPlus;
